import * as fp from 'lodash/fp';
import { startOfDay, format, addMinutes } from 'date-fns/fp';

export default function transformDayTimeToString(min: number): string {
  return fp.pipe(startOfDay, addMinutes(min), format('HH:mm'))(new Date());
}
